import { useState } from "react";
import { Typography, Tabs, Tab, Box, Stack, Paper } from "@mui/material";
import SpamList from "./spamList/spamList";
import General from "./general/general";
import { theme } from "../../../../configs/theme";
import Domains from "./domains/domains";

const cardSx = {
  bgcolor: "#fff",
  borderRadius: "15px",
  boxShadow: "1px 5px 5px 1px rgba(0,0,0,0.12)",
};

const Settings = () => {
  const [tab, setTab] = useState("general");

  const tabs = [
    { label: "General", value: "general", component: <General /> },
    { label: "Blocked Domain", value: "domains", component: <Domains /> },
    { label: "Spam List", value: "spamList", component: <SpamList /> },
  ];

  const currentTab = tabs.find((t) => t.value === tab)?.component;

  return (
    <Box sx={{ px: { xs: 1, md: 2 }, pb: 3 }}>
      <Stack spacing={0.5} sx={{ py: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: 700, color: "black" }}>
          Settings
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Configure email defaults, blocked domains, and spam filters.
        </Typography>
      </Stack>

      <Stack spacing={2}>
        <Paper elevation={0} sx={{ ...cardSx, px: { xs: 1, sm: 2 } }}>
          <Tabs
            value={tab}
            onChange={(e, value) => setTab(value)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              minHeight: 48,
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 600,
                minHeight: 48,
                borderRadius: "10px 10px 0 0",
              },
            }}
          >
            {tabs.map((t) => (
              <Tab key={t.value} label={t.label} value={t.value} theme={theme} />
            ))}
          </Tabs>
        </Paper>

        <Box>{currentTab}</Box>
      </Stack>
    </Box>
  );
};

export default Settings;
